<template>
  <div class="rate-table">
    <rate-form-modal
      :active.sync="modalForm.active"
      :rate="modalForm.rate"
      :firm="firm"
      :contract="contract"
      :contract-type-tag-id="
        filters.contractTypeTag || (contract ? contract.type_tag_id : undefined)
      "
      @submit="() => onFormSubmit()"
      @close="() => onFormClose()"
    />
    <b-field grouped>
      <base-select
        :service="$options.contractService"
        fetch-func="listTypes"
        :fetch-params="{
          created_by_firm_id: firm ? firm.id : undefined,
        }"
        :value.sync="filters.contractTypeTag"
        label="Contract Type"
        v-if="!contract"
      />
    </b-field>

    <div class="buttons">
      <!-- <b-button @click="() => (modalForm.active = true)">Create</b-button>
      <b-button @click="importRates">Import</b-button> -->
      <b-button @click="() => (modalForm.active = true)" :disabled="!contract">
        Create
      </b-button>
      <b-button @click="importRates" :disabled="!contract">Import</b-button>
      <b-button @click="exportRates">Export</b-button>
      <b-button @click="fetchRates" class="pull-right">
        <span class="fa fa-refresh" />
      </b-button>
    </div>

    <b-field horizontal label="STATUS" class="mb-1" style="width: 150px">
      <div class="block">
        <b-checkbox v-model="statuses" :native-value="0">ARCHIVED</b-checkbox>
        <b-checkbox v-model="statuses" :native-value="1">ACTIVE</b-checkbox>
      </div>
    </b-field>

    <b-input
      v-model="search"
      placeholder="Search"
      icon-right="close-circle"
      icon-right-clickable
      :disabled="ratesFiltered.length > perPage"
      @icon-right-click="
        () => (($refs.searchInput.newValue = ''), onTableSearch(''))
      "
      @input="(v) => onTableSearch(v)"
      ref="searchInput"
    ></b-input>

    <base-table
      :service="$options.rateService"
      fetch-func="all"
      :fetch-params="masterRatesParams"
      :columns="columns"
      ui-pagination
      :per-page="perPage"
      ref="baseTable"
    >
      <template
        #headerCheckbox
        v-if="!contract ? !!filters.contractTypeTag : true"
      >
        <b-field>
          <b-checkbox
            :value="isCheckedAll()"
            :disabled="!!!ratesFiltered.length"
            @input="(value) => onTableCheckAll(value)"
          />
        </b-field>
      </template>
      <template
        #rowCheckbox="{ row }"
        v-if="!contract ? !!filters.contractTypeTag : true"
      >
        <b-field>
          <b-checkbox
            :value="isChecked(row)"
            @input="(value) => onTableCheck(value, row)"
          />
        </b-field>
      </template>
      <template #rowActions="{ row }">
        <!-- <b-button size="is-small" @click="() => onRowUpdate(row)">
          UPDATE
        </b-button> -->
        <b-button size="is-small" @click="() => onRowUpdate(row)" :disabled="!contract">
          UPDATE
        </b-button>
        <rate-archive-button
          :value="!isChecked(row)"
          :props="{ size: 'is-small' }"
          @click="(value) => onTableArchive(value, row)"
          @timeout="() => onTableTimeout()"
          :key="`archiveButton-${row.id}`"
          :ref="`archiveButton-${row.id}`"
        />
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import BaseSelect from "@/components/partials/BaseSelect";
import RateArchiveButton from "@/components/Rate/RateArchiveButton";
import RateFormModal from "@/components/Rate/RateFormModal";
import { ContractService } from "@/services/contract.service";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import FlatfileImporter from "flatfile-csv-importer";
import config from "@/config";

export default {
  contractService: ContractService,
  rateService: OrderOperationClaimServiceService,
  tagService: TagService,
  props: {
    firm: {
      type: Object,
    },
    contract: {
      type: Object,
    },
  },
  components: {
    BaseTable,
    BaseSelect,
    RateArchiveButton,
    RateFormModal,
  },
  data: () => ({
    filters: {
      contractTypeTag: "",
    },
    columns: [
      {
        field: "checkbox",
        label: "",
        meta: {
          headerSlot: "headerCheckbox",
          rowSlot: "rowCheckbox",
        },
      },
      {
        field: "category",
        label: "Category",
      },
      {
        field: "code",
        label: "Code",
      },
      {
        field: "description",
        label: "Description",
      },
      {
        field: "actions",
        label: "",
        meta: {
          rowSlot: "rowActions",
        },
      },
    ],
    perPage: 1000,
    rates: [],
    ratesFiltered: [],
    ratesChecked: [],
    search: "",
    statuses: [1],
    modalForm: {
      active: false,
      rate: null,
    },
    importer: null,
    loading: false,
  }),
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    masterRatesParams() {
      return {
        firm_id: this.firm ? this.firm.id : undefined,
        tag_id: this.contract ? this.contract.type_tag_id : undefined,
        status: 1,
        is_template: 1,
        includes: "categoryTags",
      };
    },
    activeRatesParams() {
      return {
        firm_id: this.firm ? this.firm.id : undefined,
        tag_id: this.filters.contractTypeTag || undefined,
        // tag_id: this.contract
        //   ? this.contract.type_tag_id || undefined
        //   : this.filters.contractTypeTag || undefined,
        contract_id: this.contract ? this.contract.id : undefined,
        status: this.contract ? 1 : undefined,
        is_template: this.contract ? undefined : 1,
      };
    },
  },
  async mounted() {
    // Initialize FlatFileImporter
    FlatfileImporter.setVersion(2);
    if (this.contract) {
      this.importer = new FlatfileImporter(
        config.flatfileLicense,
        config.contractRateFlatfileOptions
      );
    } else {
      this.importer = new FlatfileImporter(
        config.flatfileLicense,
        config.rateFlatfileOptions
      );
    }
    this.importer.setCustomer({
      userId: this.user.id,
      name: this.user.fullName,
      email: this.user.email,
    });
    // Add rate column on contract level
    if (this.contract) {
      this.columns.splice(4, 0, {
        field: "rate",
        label: "Rate",
      });
    }
    this.fetchRates();
  },
  watch: {
    filters: {
      handler: function () {
        this.$nextTick(async () => {
          await this.fetchActiveRates();
          this.filterRates();
        });
      },
      deep: true,
    },
    statuses() {
      this.$nextTick(() => this.filterRates());
    },
    ratesFiltered(rates) {
      this.$refs.baseTable.data = rates;
    },
  },
  methods: {
    isCheckedAll() {
      if (this.ratesFiltered.length == 0) return false;
      return this.ratesFiltered.every((v) => this.isChecked(v));
    },
    isChecked(row) {
      return !!this.ratesChecked.find((v) =>
        this.contract ? v.parentRateId == row.id : v.id == row.id
      );
    },
    filterRates() {
      let ratesFiltered = [];

      // Filter by search
      if (this.search) {
        ratesFiltered = this.rates.filter((rate) => {
          let bool = false;
          let search = new RegExp(this.search, "i"); // case insensitive search
          // Category
          bool = bool ? bool : `${rate.category || ""}`.search(search) > -1;
          // Code
          bool = bool ? bool : `${rate.code || ""}`.search(search) > -1;
          // Description
          bool = bool ? bool : `${rate.description || ""}`.search(search) > -1;
          return bool;
        });
      } else {
        ratesFiltered = this.rates;
      }

      // Filter by status
      if (this.statuses.length == 2) {
        // return all
      }
      if (this.statuses.length == 1) {
        const active = this.statuses[0] == 1;
        const checkedIds = this.ratesChecked.map((rate) =>
          parseInt(this.contract ? rate.parentRateId : rate.id)
        );
        ratesFiltered = ratesFiltered.filter((rate) => {
          const rateActive = checkedIds.includes(parseInt(rate.id));
          return active ? rateActive : !rateActive;
        });
      }
      if (this.statuses.length == 0) {
        ratesFiltered = [];
      }

      this.ratesFiltered = ratesFiltered;
    },
    async fetchRates() {
      await this.fetchMasterRates();
      await this.fetchActiveRates();
      // Display contract rate->rate
      this.rates = this.rates.map((rate) => {
        const match = this.ratesChecked.find(
          (rateChecked) => rateChecked.parentRateId == rate.id
        );
        if (match) {
          rate.rate = match.rate;
        } else {
          rate.rate = null;
        }
        return rate;
      });
      this.filterRates();
    },
    async fetchMasterRates() {
      try {
        if (this.firm || (this.contract && this.contract.type_tag_id)) {
          // this.rates = await this.$refs.baseTable.fetchData(1, true);
          this.rates = await this.$refs.baseTable.fetchData();
        } else {
          this.rates = [];
          this.$refs.baseTable.data = [];
        }
      } catch (err) {
        throw err;
      }
    },
    async fetchActiveRates() {
      try {
        this.$refs.baseTable.loading = true;
        if (this.filters.contractTypeTag || this.contract) {
          this.ratesChecked = await this.$options.rateService
            .all(this.activeRatesParams)
            .then((response) => JsonDenormalizer.denormalize(response));
        } else {
          this.ratesChecked = [];
        }
      } catch (err) {
        throw err;
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    async archiveRestoreRates(mode = "archive", rates) {
      try {
        this.$refs.baseTable.loading = true;
        const ids = rates.map((v) => v.id);
        if (mode === "archive") {
          if (this.contract) {
            await this.$options.rateService.archiveByParentRate({
              contract_id: this.contract.id,
              parent_rate_ids: ids,
            });
            // await this.fetchActiveRates();
          } else {
            await this.$options.tagService.archiveRates(
              this.filters.contractTypeTag,
              { rate_ids: ids }
            );
          }
        } else {
          if (this.contract) {
            await this.$options.rateService.restoreByParentRate({
              contract_id: this.contract.id,
              parent_rate_ids: ids,
            });
            // await this.fetchActiveRates();
          } else {
            await this.$options.tagService.restoreRates(
              this.filters.contractTypeTag,
              {
                rate_ids: ids,
              }
            );
          }
        }
        await this.fetchActiveRates();
        this.$buefy.toast.open({
          message: `Rates has been ${mode}d.`,
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    async importRates() {
      let rates = await this.$options.rateService
        .all(this.masterRatesParams)
        .then((response) => JsonDenormalizer.denormalize(response));

      const rateCodes = rates.map((v) => v.code.toLowerCase());

      let fileRates = [];
      this.importer.registerRecordHook((record, key) => {
        // Reset file rates
        if (key === 1) fileRates = [];

        let error = {};
        const rateCode = record.code.toLowerCase();
        let fileRateCodes = fileRates.map((v) => v.code.toLowerCase());
        if (fileRateCodes.includes(rateCode)) {
          error.code = {
            info: [
              {
                message:
                  "Duplicate: Import file contains multiple records of this code.",
                level: "error",
              },
            ],
          };
        }
        fileRates.push(record);
        return error;
      });
      await this.importer.requestDataFromUser().then(async (response) => {
        let data = response.data;
        try {
          await this.$options.rateService.import({
            firm_id: this.firm.id,
            contract_id: this.contract ? this.contract.id : undefined,
            contract_type_tag_id: this.filters.contractTypeTag || undefined,
            data,
          });
          this.importer.close();
          this.fetchRates();
          this.$buefy.toast.open({
            message: "Rates successfully imported.",
            type: "is-info",
            position: "is-top-right",
          });
        } catch (err) {
          // this.importer.displayError(err.message);
          this.importer.close();
        }
      });
    },
    exportRates() {
      if (this.ratesFiltered.length == 0) return;
      let csv = "Category,Code,Description,Rate,UOM,Display Order\n";
      let csvData = this.ratesFiltered.map((rate) => [
        rate.category ? `\"${rate.category}\"` : "",
        rate.code,
        rate.description ? `\"${rate.description}\"` : "",
        rate.rate,
        rate.uom,
        rate.displayOrder,
      ]);
      csvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      var download = document.createElement("a");
      download.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      download.target = "_blank";
      download.download = `rates-${this.statuses
        .sort()
        .join("")}-${Math.random().toString().substr(2, 5)}.csv`;
      download.click();
    },
    onFormSubmit() {
      this.fetchRates();
    },
    onFormClose() {
      this.modalForm.rate = null;
    },
    onTableCheck(checked, row) {
      this.$nextTick(async () => {
        if (row) {
          await this.archiveRestoreRates(
            // !!this.ratesChecked.find((c) => c.id == row.id)
            //   ? "restore"
            //   : "archive",
            checked ? "restore" : "archive",
            [row]
          );
        }
      });
    },
    onTableCheckAll(checked) {
      this.$nextTick(async () => {
        // const ratesVisible = (
        //   this.$refs.baseTable.$refs.btable.visibleData || []
        // ).map((c) => c.id);
        await this.archiveRestoreRates(
          // this.ratesChecked
          //   .filter((cc) => ratesVisible.includes(cc.id))
          //   .filter((cc) => !!this.ratesFiltered.find((cf) => cf.id == cc.id))
          //   .length
          //   ? "restore"
          //   : "archive",
          // this.ratesFiltered.filter((cc) => ratesVisible.includes(cc.id))
          checked ? "restore" : "archive",
          this.ratesFiltered
        );
      });
    },
    onTableSearch: _.debounce(function () {
      if (this.search.length >= 3) {
        this.filterRates();
        // this.$refs.baseTable.pagination.perPage = 10000;
        this.$refs.baseTable.pagination.perPage = this.perPage;
      }
      if (this.search.length == 0) {
        this.filterRates();
        this.$refs.baseTable.pagination.perPage = this.perPage;
      }
    }, 500),
    onTableArchive(archive, row) {
      this.$nextTick(async () => {
        if (row) {
          await this.archiveRestoreRates(archive ? "archive" : "restore", [
            row,
          ]);
          this.$refs[`archiveButton-${row.id}`].startTimer();
        }
      });
    },
    onTableTimeout() {
      this.filterRates();
    },
    onRowUpdate(row) {
      this.modalForm.rate = row;
      this.modalForm.active = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Rate/RateTableNew.vue